import { ICompanyDataModel } from '../../data-models/company.data-model';
import { baseSampleSeeds } from '../../components/FrostedGate/sample-seeds';
import { SampleSeed, seed } from '../../components/FrostedGate/SampleScope';
import { customFieldsListAtom } from '../../services/state/AdminPanel/CustomFieldsStateJ';
import { kpiTemplateAssignmentsListStateJ } from '../../services/state/KPI/KPICompaniesStateJ';
import { kpiTemplatesListStateJ } from '../../services/state/KPI/KPITemplatesStateJ';
import { PREVIEW_KPI_TEMPLATE_ASSIGNMENTS, PREVIEW_KPI_TEMPLATES } from './kpi-module.fixtures';

/** What every KPI screen's grid schema reads: the portfolio and the templates it names. */
export function kpiBaseSeeds(companies: ICompanyDataModel[]): SampleSeed[] {
  return [...baseSampleSeeds(companies), seed(kpiTemplatesListStateJ, PREVIEW_KPI_TEMPLATES)];
}

/** Everything the KPI Companies page reads on top of that. */
export function kpiCompanySeeds(companies: ICompanyDataModel[]): SampleSeed[] {
  return [
    ...kpiBaseSeeds(companies),
    seed(kpiTemplateAssignmentsListStateJ, PREVIEW_KPI_TEMPLATE_ASSIGNMENTS),
    seed(customFieldsListAtom, []),
  ];
}
